// Industriewarenhandel — Startseite (Interaktionen), gescoped auf .iw-home
(function () {
  'use strict';
  var root = document.querySelector('.iw-home');
  if (!root) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Sticky-Header-Zustand
  var header = root.querySelector('#iw-header');
  function onScroll() { if (header) header.classList.toggle('scrolled', window.scrollY > 8); }
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

  // Reveal on Scroll
  var reveals = root.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else { reveals.forEach(function (el) { el.classList.add('in'); }); }

  // Mobiles Menü
  var burger = root.querySelector('#iw-burger');
  var drawer = root.querySelector('#iw-drawer');
  var overlay = root.querySelector('#iw-overlay');
  var closeBtn = root.querySelector('#iw-drawer-close');
  var lastFocus = null;
  function foc() { return drawer ? drawer.querySelectorAll('a[href],button:not([disabled])') : []; }
  function openMenu() {
    lastFocus = document.activeElement;
    drawer.classList.add('open'); overlay.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false'); burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    var f = foc(); if (f.length) f[0].focus();
  }
  function closeMenu() {
    drawer.classList.remove('open'); overlay.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true'); burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  if (burger) burger.addEventListener('click', openMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (drawer) drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeMenu); });
  document.addEventListener('keydown', function (e) {
    if (!drawer) return;
    if (e.key === 'Escape' && drawer.classList.contains('open')) closeMenu();
    if (e.key === 'Tab' && drawer.classList.contains('open')) {
      var f = Array.prototype.slice.call(foc()); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  // Suche-Icon fokussiert Hero-Suchfeld
  var sToggle = root.querySelector('#iw-search-toggle');
  var sInput = root.querySelector('.search-field input');
  if (sToggle && sInput) {
    sToggle.addEventListener('click', function () {
      sInput.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      setTimeout(function () { sInput.focus(); }, reduce ? 0 : 300);
    });
  }
  // Chips füllen Suche
  root.querySelectorAll('.chip[data-search-term]').forEach(function (c) {
    c.addEventListener('click', function () { if (sInput) { sInput.value = c.getAttribute('data-search-term') || c.textContent.trim(); sInput.focus(); } });
  });

  // Produktseite: Menge +/-
  var qtyInput = root.querySelector('#pdp-qty');
  // Menge zwischen 1 und dem verfuegbaren Bestand halten (max ist nur gesetzt, wenn Shopify den Bestand begrenzt).
  function clampQty(val) {
    var max = qtyInput && qtyInput.max ? parseInt(qtyInput.max, 10) : NaN;
    val = Math.max(1, isNaN(val) ? 1 : val);
    return isNaN(max) ? val : Math.min(max, val);
  }
  root.querySelectorAll('.qty button[data-q]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!qtyInput) return;
      qtyInput.value = clampQty(parseInt(qtyInput.value || '1', 10) + parseInt(b.getAttribute('data-q'), 10));
    });
  });
  if (qtyInput) {
    qtyInput.addEventListener('change', function () { qtyInput.value = clampQty(parseInt(qtyInput.value, 10)); });
  }

  // Produktseite: Galerie-Thumbnails
  var mainImg = root.querySelector('#pdp-main-img');
  var thumbs = root.querySelectorAll('.pdp-thumbs button');
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      if (mainImg && t.getAttribute('data-full')) mainImg.src = t.getAttribute('data-full');
      thumbs.forEach(function (x) { x.classList.remove('active'); x.setAttribute('aria-pressed', 'false'); });
      t.classList.add('active');
      t.setAttribute('aria-pressed', 'true');
    });
  });
})();
